import type { HTMLAttributes } from 'react';
import { cn } from '../../../../lib/utils.js';

export type AvatarSize = 'sm' | 'md' | 'lg';

const sizeClasses: Record<AvatarSize, string> = {
  sm: 'h-8 w-8 text-label-12',
  md: 'h-10 w-10 text-body-14',
  lg: 'h-14 w-14 text-body-16',
};

export interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  /** Source URL for avatar image. */
  src?: string;
  /** Alternative text for avatar image. */
  alt?: string;
  /** Fallback initials when no image is provided. */
  initials?: string;
  /** Size token controlling avatar dimensions. */
  size?: AvatarSize;
}

export function Avatar({ src, alt, initials = 'IG', size = 'md', className, ...props }: AvatarProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center overflow-hidden rounded-full border border-ig-border bg-ig-bg-secondary font-semibold text-ig-text-primary',
        sizeClasses[size],
        className
      )}
      {...props}
    >
      {src ? <img src={src} alt={alt ?? 'Avatar'} className="h-full w-full object-cover" /> : <span>{initials}</span>}
    </div>
  );
}
